export type MonthStamp = number;

export interface LimitedResponseLimitInfo {
  unlimited: false;
  remaining: number;
  limit: number;
  /* eslint-disable camelcase */
  limit_changed_epoch_time: number;
  limit_changed_type: 'upgrade' | 'downgrade';
  time_period: MonthStamp;
}

export interface LimitedResponseNotReceivedInfo {
  unlimited: false;
  remaining: number;
  limit: number;
}

export interface UnlimitedResponseLimitInfo {
  unlimited: true;
}

export type ResponseLimitInfo =
  | LimitedResponseLimitInfo
  | LimitedResponseNotReceivedInfo
  | UnlimitedResponseLimitInfo;

export type UpgradeInfo = {
  date: number;
  hide: boolean;
};

export const convertMonthStampToDate = (monthStamp: MonthStamp): Date => {
  const year = Number(monthStamp.toString().slice(0, 4));
  const month = Number(monthStamp.toString().slice(4, 6));

  return new Date(Date.UTC(year, month));
};
